import { useState, useEffect, useRef } from 'react';
import fetchExpresso from 'utility/fetchExpresso';

export function useSalesSummary(eventId, startDate, endDate) {
    const requestIdRef = useRef(0);

    const [state, setState] = useState({
        dataStatus: 'empty', // empty, ready, error
        fetchStatus: 'fetching', // idle, fetching
        salesReport: null,
        payout: null,
        incidental: null,
        event: null,
    });

    useEffect(() => {
        const requestId = ++requestIdRef.current;
        setState((s) => ({
            ...s,
            dataStatus: s.dataStatus === 'ready' ? 'ready' : 'empty',
            fetchStatus: 'fetching',
        }));

        let range = '';

        if (startDate && endDate) {
            range = `?start=${startDate}&end=${endDate}`;
        }

        fetchExpresso(`/apiv2/events/${eventId}/summary/sales${range}`)
            .then((response) => {
                if (requestId !== requestIdRef.current) {
                    return null;
                }
                if (response.status !== 200) {
                    throw new Error();
                }
                return response.json();
            })
            .then((data) => {
                if (requestId !== requestIdRef.current || !data) {
                    return;
                }

                setState((s) => ({
                    ...s,
                    dataStatus: 'ready',
                    fetchStatus: 'idle',
                    salesReport: data,
                    payout: data.payout,
                    incidental: data.incidental,
                    event: data.event,
                }));
            })
            .catch(() => {
                if (requestId !== requestIdRef.current) {
                    return;
                }

                setState((s) => ({
                    ...s,
                    dataStatus: 'error',
                    fetchStatus: 'idle',
                }));
            });
    }, [eventId, startDate, endDate]);

    return state;
}
